<template>
  <b-sidebar
    id="add-new-service-sidebar"
    :visible="isAddNewServiceSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="handleHidden"
    @change="(val) => $emit('update:is-add-new-service-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <div
        v-if="serviceData"
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ button_text }} New Service</h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>
      <b-col
        cols="12"
        v-if="serviceData.image_url"
        class="d-flex justify-content-center"
      >
        <img
          style="width: 100%; max-width: 300px"
          :src="serviceData.image_url"
        />
      </b-col>
      <!-- Body -->
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <span
            style="
              margin-bottom: 0.2857rem;
              color: #5e5873;
              font-size: 0.857rem;
            "
            >Service Image</span
          >
          <el-upload
            class="avatar-uploader"
            list-type="picture-card"
            ref="upload"
            :action="uploadUrl"
            :headers="headerObj"
            name="image_file"
            :file-list="fileList"
            multiple
            :limit="1"
            :data="serviceData"
            :on-success="uploadSuccess"
            :on-error="uploadFail"
            :on-change="onChange"
            :before-remove="beforeRemove"
            :on-remove="toggleUpload"
            :auto-upload="false"
            :class="{ hideUpload: !showUpload }"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <b-form-group label="Service Slug" label-for="service_slug">
            <b-form-input
              id="service_slug"
              v-model="serviceData.slug"
              autofocus
              trim
              placeholder="Enter a unique identifier (slug)"
            />
          </b-form-group>
          <b-form-group label="Has Information?" label-for="has_information">
            <b-form-checkbox
              :checked="serviceData.has_information"
              name="has_information"
              :value="1"
              :unchecked-value="0"
              switch
              inline
              v-model="serviceData.has_information"
            >
              {{ serviceData.has_information ? "Yes" : "No" }}
            </b-form-checkbox>
          </b-form-group>
          <div v-if="serviceData.has_information">
            <!-- Service Slug -->

            <!-- Service TITLE -->
            <b-form-group label="Service Title" label-for="service_title">
              <b-form-input
                id="service_title"
                v-model="serviceData.title"
                autofocus
                trim
                placeholder="Service Title"
              />
            </b-form-group>

            <b-form-group
              label="Service Description"
              label-for="service_description"
            >
              <b-form-textarea
                id="service_description"
                v-model="serviceData.description"
                autofocus
                trim
                rows="3"
                placeholder="Service Description"
              />
            </b-form-group>
            <!-- Service CONTENT -->
            <b-form-group label="Service Content" label-for="service_content">
              <TinyMCEEditor
                :key="trigger"
                :content.sync="serviceData.content"
              />
            </b-form-group>
          </div>
          <!-- <b-form-group v-else label="Service Content" label-for="service_content">
            <TinyMCEEditor key="content2" :content.sync="serviceData.content" />
          </b-form-group> -->

          <b-form-group label="Sort Order" label-for="sort_order">
            <b-form-input type="number" v-model="serviceData.sort_order" />
          </b-form-group>

          <b-form-group label="Is Active?" label-for="is_active">
            <b-form-checkbox
              :checked="serviceData.is_active"
              name="is_active"
              switch
              inline
              v-model="serviceData.is_active"
            >
              {{ serviceData.is_active ? "Active" : "Inactive" }}
            </b-form-checkbox>
          </b-form-group>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
            >
              {{ button_text }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancel
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
  BFormTextarea,
  BCol,
  BMedia,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BImg,
  BCardText,
  BFormCheckbox,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ref, watch, onMounted } from "@vue/composition-api";
import { required, alphaNum } from "@validations";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import store from "@/store";
import { getUserData } from "@/auth/utils";
// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import useServicesList from "./useServicesList";
import TinyMCEEditor from "@/layouts/components/TinyMCEEditor.vue";

import "quill/dist/quill.core.css";
// eslint-disable-next-line
import "quill/dist/quill.snow.css";
// eslint-disable-next-line
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormTextarea,
    BButton,
    vSelect,
    BCol,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BImg,
    BCardText,
    BFormCheckbox,
    quillEditor,
    TinyMCEEditor,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: "isAddNewServiceSidebarActive",
    service: "update:is-add-new-service-sidebar-active",
  },
  props: {
    isAddNewServiceSidebarActive: {
      type: Boolean,
      required: true,
    },
    id: {
      type: Number,
      required: true,
    },
    getHasInformation: {
      type: Number,
      required: true,
    }
  },
  methods: {
    hide() {
      this.$emit("update:is-add-new-service-sidebar-active", false);
    },
    handleHidden() {
      this.resetForm();
      this.isHtmlMode = false;
    },
    toggleUpload() {
      this.showUpload = !this.showUpload;
    },
    getImgPath(path) {
      return process.env.VUE_APP_IMAGE_URL + path;
    },
    onSubmit() {
      this.$swal({
        title: "Are you sure?",
        showCancelButton: true,
        confirmButtonText: "Save",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          let formData = new FormData();
          formData.append("id", this.serviceData.id);
          if (this.serviceData.file) {
            formData.append("image_file", this.serviceData.file);
          }

          formData.append("store_id", getUserData().store_id);
          formData.append("has_information", this.serviceData.has_information ? 1 : 0);
          formData.append("slug", this.serviceData.slug);
          if (this.serviceData.has_information) {
            formData.append("title", this.serviceData.title);
            formData.append("description", this.serviceData.description);
            formData.append("content", this.serviceData.content);
          }else{
            formData.append("title", null);
            formData.append("description", null);
            formData.append("content", null);

          }

          formData.append("sort_order", this.serviceData.sort_order);
          formData.append("is_active", this.serviceData.is_active ? 1 : 0);

          this.loading = true;
          store
            .dispatch("bar-service/addService", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.showUpload = true;
              this.$emit("refetch-data");
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: JSON.stringify(error.response.data.message),
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  data() {
    return {
      required,
      alphaNum,
      isHtmlMode: true,
    };
  },
  setup(props, { emit }) {
    const refInputEl = ref(null);
    const refPreviewEl = ref(null);
    const upload = ref(null);
    const uploadUrl = ref(process.env.VUE_APP_SERVICE_URL + "/service");
    const headerObj = {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    };
    const fileList = ref([]);
    const button_text = ref("Add");
    const showUpload = ref(true);
    const loading = ref(false);

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        refPreviewEl.value.src = base64;
      }
    );

    const blankServiceData = {
      id: 0,
      title: "",
      description: "",
      content: "",
      sort_order: 0,
      has_information: props.getHasInformation,
      is_active: true,
      store_id: getUserData().store_id,
      image_url: "",
      slug: "",
      price: "",
    };
    const trigger = ref(0);
    watch(
      () => [props.id, props.isAddNewServiceSidebarActive],
      () => {
        trigger.value++;
        /* ... */
        if (props.id > 0 && props.isAddNewServiceSidebarActive) {
          store
            .dispatch("bar-service/fetchService", props.id)
            .then((response) => {
              serviceData.value = { ...response.data.service };
              serviceData.value.is_active = Boolean(
                serviceData.value.is_active
              );

              console.log("serviceData.value", serviceData.value);
              if (props.id > 0) {
                button_text.value = "Edit";
              } else {
                button_text.value = "Add";
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else if (props.id == 0) {
          serviceData.value = JSON.parse(JSON.stringify(blankServiceData));
          fileList.value = [];
          button_text.value = "Add";
        }
      }
    );

    const serviceData = ref(JSON.parse(JSON.stringify(blankServiceData)));
    console.log('serviceData.value.has_information', serviceData.value.has_information)
    const resetserviceData = () => {
      serviceData.value = JSON.parse(JSON.stringify(blankServiceData));
      fileList.value = [];
      button_text.value = "Add";
    };

    const updateserviceData = (service) => {
      serviceData.value = service;
    };

    const beforeRemove = (file) => {
      serviceData.value.file = null;
    };

    const onChange = (file, fileLists) => {
      fileList.value = fileLists;
      serviceData.value.file = file.raw;
      showUpload.value = !showUpload.value;
    };

    /*
    const onSubmit = () => {
      console.log(fileList.value);
      if (serviceData.value.id > 0) {
        if (fileList.value[0].url.includes(process.env.VUE_APP_IMAGE_URL)) {
          //Check if user didn't change photo
          console.log(`user didn't change photo`);
          store
            .dispatch("bar-service/addService", serviceData.value)
            .then((response) => {
              uploadSuccess();
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          console.log(`user changed photo`);
          upload.value.submit();
        }
      } else {
        upload.value.submit();
      }
    };
    */

    const uploadSuccess = (res, file, fileList) => {
      emit("refetch-data");
      emit("update:is-add-new-service-sidebar-active", false);
      showMessage(
        "Success",
        "Successfully inserted new service.",
        "CheckIcon",
        "success"
      );
    };

    const uploadFail = (err, file, fileList) => {
      //showMessage('Fail', err, 'HeartIcon', 'danger')
      console.log("upload Fail");
    };

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetserviceData);

    const { showMessage } = useServicesList();

    return {
      refInputEl,
      serviceData,
      //onSubmit,
      beforeRemove,
      refFormObserver,
      getValidationState,
      resetForm,
      inputImageRenderer,
      refPreviewEl,
      upload,
      uploadUrl,
      uploadSuccess,
      uploadFail,
      onChange,
      headerObj,
      updateserviceData,
      fileList,
      button_text,
      showUpload,
      loading,
      trigger,
    };
  },
};
</script>


<style>
</style>